import { render, staticRenderFns } from "./PagarBarbeiro.vue?vue&type=template&id=02336274&scoped=true&"
import script from "./PagarBarbeiro.vue?vue&type=script&lang=js&"
export * from "./PagarBarbeiro.vue?vue&type=script&lang=js&"
import style0 from "./PagarBarbeiro.vue?vue&type=style&index=0&id=02336274&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02336274",
  null
  
)

export default component.exports